import { getFeaturebaseToken as _getFeaturebaseToken } from '@griply/services';
import { httpsCallable } from 'firebase/functions';

import { getFunctions } from './helpers';

export const getFeaturebaseToken = () =>
  _getFeaturebaseToken({ functions: getFunctions(), httpsCallable });
